import { Input } from '@starsoft/common/components';
import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';

export default function CoinSkeleton() {
  return (
    <div className={`${styles.container} ${styles['container--loading']}`}>
      <Input type="radio" isLoading />
      <div className={skeleton.text} />
      <div className={skeleton.coin} />
    </div>
  );
}
